import type { NextApiRequest, NextApiResponse } from 'next'
import * as cookie from 'cookie'
import { sanitizeRedirectPathToUrl } from '@reward-platform/utils'

const DEFAULT_COOKIE_MAX_AGE_IN_SECONDS = 60

export const serializeCookie = (name: string, value: string, options?: cookie.SerializeOptions) =>
  cookie.serialize(name, value, {
    path: '/',
    maxAge: DEFAULT_COOKIE_MAX_AGE_IN_SECONDS,
    ...options,
  })

export const getCookiesFromRequest = (req: NextApiRequest) => {
  return cookie.parse(req.headers.cookie ?? '')
}

export const setCookieInResponse = (res: NextApiResponse, cookies: string | string[]) => {
  return res.setHeader('Set-Cookie', cookies)
}

export const getSanitizedReturnTo = (
  returnTo: string,
  validationBaseUrl: string
): string | undefined => {
  const safeBaseUrl = new URL(validationBaseUrl)
  const sanitizedReturnToUrl = sanitizeRedirectPathToUrl(returnTo, safeBaseUrl)

  if (!sanitizedReturnToUrl) {
    return sanitizedReturnToUrl
  }

  return `${sanitizedReturnToUrl.pathname}${sanitizedReturnToUrl.search ?? ''}`
}
